var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m14.159 10.251-.08 2.923c2.547.89 4.341 3.765 4.258 6.837L5.66 19.933c.084-3.071 2.02-5.924 4.615-6.783l.08-2.922C9.24 9.509 8.511 8.174 8.552 6.65l7.606.047c-.042 1.523-.843 2.849-2 3.553Zm.322 9.725-.594 2.485h-3.876l-.495-2.493 4.965.008Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpin);
export default __webpack_public_path__ + "static/media/unpin.d24f2af454463f8016d47ff66e8195f4.svg";
export { ForwardRef as ReactComponent };